export default __webpack_public_path__ + "static/media/f_custom.32074e90.svg";